module.exports = __webpack_public_path__ + "static/media/background_FIN.4d54cc3d.jpg";